import { ChevronIcon } from '@chegg-ui/theme'
import { FC } from 'react'
import {
  AccordionContainer,
  AccordionContent,
  AccordionHeader,
  AccordionToggleButton,
} from './styled'

type AccordionProps = {
  title: string
  children: JSX.Element | string
  dataTestId?: string
  showCaret?: boolean
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
}

const Accordion: FC<AccordionProps> = ({
  title,
  dataTestId,
  showCaret = true,
  isExpanded,
  setIsExpanded,
  children,
}) => {
  const caretIcon = showCaret && (
    <ChevronIcon color="#2e8aee" size="xsmall" pointing={isExpanded ? 'up' : 'down'} />
  )
  return (
    <AccordionContainer data-test={dataTestId}>
      <AccordionHeader>
        <AccordionToggleButton onClick={() => setIsExpanded(!isExpanded)}>
          <span>{title}</span>
          {caretIcon}
        </AccordionToggleButton>
      </AccordionHeader>
      {isExpanded && <AccordionContent>{children}</AccordionContent>}
    </AccordionContainer>
  )
}

export default Accordion
